import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-star",
  "use": "icon-star-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-star\"><path d=\"M565.312 34.613l112.027 237.49a59.82 59.82 0 0 0 44.785 34.036l250.797 38.387a62.955 62.955 0 0 1 32.95 105.95L824.361 635.373a63.979 63.979 0 0 0-17.018 54.958l42.802 261.034a60.076 60.076 0 0 1-86.244 65.514L539.656 893.337a57.005 57.005 0 0 0-55.278 0l-224.31 123.224a60.012 60.012 0 0 1-86.18-65.515l43.187-261.226a63.979 63.979 0 0 0-17.147-54.958l-181.7-184.707a62.827 62.827 0 0 1 32.885-105.82l250.734-38.388a59.756 59.756 0 0 0 44.785-34.037L458.659 34.613a58.349 58.349 0 0 1 106.589 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/star.svg
// module id = 60zo
// module chunks = 65